/**
 * @module The User Flags
 */

import {ENUM} from '@acng/frontend-rubicon';
import {keys} from '@acng/frontend-bounty/object.js';

import {portal} from '../../core/portal.js';
import {authUser} from '../context/auth-user.js';

export const AUTH = 'auth';
export const GUEST = 'guest';
export const NATIVE = 'native';
export const PREMIUM = 'premium';
export const FREE = 'free';

export const checkFlag = {
  [AUTH]: () => !!authUser,
  [GUEST]: () => !authUser,
  [NATIVE]: () => !(authUser?.is_international ?? portal.is_international),
  [PREMIUM]: () => (authUser?.level ?? 0) >= 10,
  [FREE]: () => (authUser?.level ?? 0) < 10,
};

export const FLAG = /* @__PURE__ */ ENUM(keys(checkFlag));
